import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { BaseServicesService } from './services/base-services.service';
import { RedirectGuardService } from './services/RedirectGuard.service';

const baseService = new BaseServicesService();

const APP_ROUTES: Routes = [
  { path: '', canActivate: [RedirectGuardService], component: RedirectGuardService, pathMatch: 'full',
    data: { externalUrl: baseService.getPath() },
  },
  { path: '', loadChildren: (): any => import('./layouts/no-layouts/no-layouts.module').then((mod) => mod.NoLayoutsModule) },
  { path: '', loadChildren: (): any => import('./layouts/shared-layouts/shared-layouts.module').then((mod) => mod.SharedLayoutsModule) }
];

@NgModule({
  imports: [
    RouterModule.forRoot(APP_ROUTES, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})


export class AppRoutingModule { }
